// 使い方: Input +8108011112223, Output: 080-1111-2223
export function formatJapanesePhoneNumber(input: string): string {
  if (input === "" || input === null || input === undefined) return "";

  const localNumber = input.slice(3).startsWith("0") ? input.slice(3) : "0" + input.slice(3);
  const formatted = localNumber.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3");
  return formatted;
}
